// Generated from the approved MagicPath revision 440407832962146304. Do not hand-edit; update the source worktree instead.
import { FormEvent, useState } from 'react';
const firstHourPlate = "/assets/page08-first-hour.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const moments = [{
  minute: '00',
  label: 'WAKE'
}, {
  minute: '15',
  label: 'NO INPUT'
}, {
  minute: '30',
  label: 'MOVE'
}, {
  minute: '45',
  label: 'GET STILL'
}, {
  minute: '60',
  label: 'SET THE DAY'
}];
export const Page08StartTomorrowMorning = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  const [formOpen, setFormOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };
  return <main className="first-hour-page">
    <img className="first-hour-photo" src={firstHourPlate} alt="Open ocean at sunrise" />
    <div className="first-hour-grade" aria-hidden="true" />

    <button className="first-hour-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="first-hour-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button key={item} type="button" className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>

    <section className="first-hour-copy" aria-labelledby="first-hour-heading">
      <p className="first-hour-eyebrow">START TOMORROW MORNING</p>
      <span className="first-hour-rule" aria-hidden="true" />
      <h1 id="first-hour-heading">HARDEN YOUR MIND<br />BEFORE THE WORLD<br />GETS ACCESS TO IT.</h1>
      <p className="first-hour-intro">60 minutes. No noise. No input.<br />Build the edge before the world<br />builds its demands.</p>
      {!formOpen && <button className="first-hour-cta" type="button" onClick={() => setFormOpen(true)}>GET THE FIRST HOUR CARD</button>}
      {formOpen && !submitted && <form className="first-hour-form" onSubmit={submit}>
        <label><span>FIRST NAME</span><input name="firstName" required autoFocus /></label>
        <label><span>PRIVATE EMAIL</span><input name="email" type="email" required /></label>
        <button type="submit">SEND CARD</button>
      </form>}
      {submitted && <p className="first-hour-confirmation" role="status">THE CARD IS ON ITS WAY.</p>}
    </section>

    <ol className="first-hour-timeline" aria-label="The first hour">
      {moments.map((moment, index) => <li key={moment.minute} className={index === 0 ? 'active' : ''}>
        <strong>{moment.minute}</strong><i aria-hidden="true" /><span>{moment.label}</span>
      </li>)}
    </ol>

    <footer className="first-hour-footer"><strong>08</strong><i>/ 11</i><span>START TOMORROW MORNING</span></footer>
  </main>;
};